import { render, staticRenderFns } from "./ContactMemberships.vue?vue&type=template&id=1a7b8488&"
import script from "./ContactMemberships.vue?vue&type=script&lang=ts&"
export * from "./ContactMemberships.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7b8488')) {
      api.createRecord('1a7b8488', component.options)
    } else {
      api.reload('1a7b8488', component.options)
    }
    module.hot.accept("./ContactMemberships.vue?vue&type=template&id=1a7b8488&", function () {
      api.rerender('1a7b8488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contact/ContactMemberships.vue"
export default component.exports